// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"921d78f4","375":"7a705391","384":"3e84fac7","495":"75cb7693","585":"c71ddbba","763":"bbb7e9e4","856":"178e6a8a","874":"3c3698e3","971":"c536b278"}[chunkId] + ".chunk.js";
};